import req from './http'
import urls from './urls'
// additional_information
export const createAdditionalInformation = (params: object) => {
  return req.post(urls.additional_information, params)
}

export const readAdditionalInformation = () => {
  return req.get(urls.additional_information)
}

export const updateAdditionalInformation = (params: object) => {
  return req.put(urls.additional_information, params)
}

export const deleteAdditionalInformation = (params: object) => {
  return req.delete(urls.additional_information, { data: params })
}
// essential
export const createEssential = (params: object) => {
  return req.post(urls.essential, params)
}

export const readEssential = () => {
  return req.get(urls.essential)
}

export const updateEssential = (params: object) => {
  return req.put(urls.essential, params)
}

export const deleteEssential = (params: object) => {
  return req.delete(urls.essential, { data: params })
}
// internal_ids
export const createInternalIds = (params: object) => {
  return req.post(urls.internal_ids, params)
}

export const readInternalIds = () => {
  return req.get(urls.internal_ids)
}

export const updateInternalIds = (params: object) => {
  return req.put(urls.internal_ids, params)
}

export const deleteInternalIds = (params: object) => {
  return req.delete(urls.internal_ids, { data: params })
}
// import_records
export const createImportRecords = (params: object) => {
  return req.post(urls.import_records, params)
}

export const readImportRecords = () => {
  return req.get(urls.import_records)
}

export const updateImportRecords = (params: object) => {
  return req.put(urls.import_records, params)
}

export const deleteImportRecords = (params: object) => {
  return req.delete(urls.import_records, { data: params })
}

export const apis:any = {
  // additional_information
  createAdditionalInformation: createAdditionalInformation,
  readAdditionalInformation: readAdditionalInformation,
  updateAdditionalInformation: updateAdditionalInformation,
  deleteAdditionalInformation: deleteAdditionalInformation,
  // essential
  createEssential: createEssential,
  readEssential: readEssential,
  updateEssential: updateEssential,
  deleteEssential: deleteEssential,
  // internal_ids
  createInternalIds: createInternalIds,
  readInternalIds: readInternalIds,
  updateInternalIds: updateInternalIds,
  deleteInternalIds: deleteInternalIds,
  // import_records
  createImportRecords: createImportRecords,
  readImportRecords: readImportRecords,
  updateImportRecords: updateImportRecords,
  deleteImportRecords: deleteImportRecords
}
export default apis
